import DesignSystems from "../../../../src/blog/documenting-design-tokens/DesignSystems";
import * as React from 'react';
export default {
  DesignSystems,
  React
};